import { render, staticRenderFns } from "./password-status.component.vue?vue&type=template&id=5fa104a0&"
import script from "./password-status.component.vue?vue&type=script&lang=ts&"
export * from "./password-status.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports